import { CURRENT_CLIENT } from '@/constants'

export function isPublicOrganisationsEnabled(): boolean {
  return Boolean(
    (CURRENT_CLIENT as { features?: { publicOrganisations?: { enabled?: boolean } } }).features
      ?.publicOrganisations?.enabled,
  )
}

export function isOrganisationFollowEnabled(): boolean {
  return (
    isPublicOrganisationsEnabled() &&
    Boolean(
      (CURRENT_CLIENT as { features?: { organisationFollow?: { enabled?: boolean } } }).features
        ?.organisationFollow?.enabled,
    )
  )
}

export function candidateOrganisationPath(slug: string): string {
  const id = slug.trim()
  if (!id) return '/candidate/jobs'
  return `/candidate/organisations/${encodeURIComponent(id)}`
}

/** In-app company profile when the tenant publishes orgs and the job has a tenant org slug. */
export function candidateOrganisationHrefForJob(
  organisationSlug: string | null | undefined,
): string | null {
  if (!isPublicOrganisationsEnabled()) return null
  const slug = organisationSlug?.trim() || ''
  if (!slug) return null
  return candidateOrganisationPath(slug)
}

export function candidateFromJobBackLabel(title: string): string {
  const name = title.trim() || 'job'
  return `Back to ${name}`
}

export function candidateFromOrganisationBackLabel(name: string): string {
  const label = name.trim() || 'company'
  return `Back to ${label}`
}
